import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getViolationRiderName } from '../utils/violations';

// «От: Имя Фамилия (@ник)» у присланной тренировки, ссылка ведет в профиль
// гонщика. В карточке списка клик по ссылке не должен открывать саму тренировку
const WorkoutSharedBy = ({ sender, className = '' }) => {
  const { t, language } = useLanguage();
  if (!sender) return null;

  return (
    <span className={`workout-shared-by ${className}`}>
      {t('workouts.share.from')}{' '}
      <Link
        to={`/riders/${sender.id}`}
        onClick={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
        draggable={false}
      >
        {getViolationRiderName(sender, language)} (@{sender.nickname})
      </Link>
    </span>
  );
};

export default WorkoutSharedBy;
